export const projectHeader = [
    {
        "label": "address",
        "value": "Address",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "created_at",
        "value": "Created At",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_by",
        "value": "Created By",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "developer_name",
        "value": "Developer Name",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "project_id",
        "value": "Project Id",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "project_name",
        "value": "Name",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "project_status",
        "value": "Project Status",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "property_stage",
        "value": "Property Stage",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "property_type",
        "value": "Property Type",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "rera_link",
        "value": "Rera Link",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "walkthrough_link",
        "value": "Walkthrough Link",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "status",
        "value": "Status",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "profile",
        "value": "Profile",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "project_image",
        "value": "Project image",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "organization_name",
        "value": "Organization Name",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "project_id",
        "value": "Project Id",
        "is_mandatory": "true",
        "hide_field": "false"
    }
]

export const conatctHeader=[
    {
        "label": "Id",
        "value": "ID",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "alternate_no",
        "value": "Alternate No",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "associate_status",
        "value": "Associate Status",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "budget",
        "value": "Budget",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "contact_no",
        "value": "Contact No",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "contact_owner_email",
        "value": "Contact Owner Email",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "country_code",
        "value": "Country Code",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "lead_type",
        "value": "Lead Type",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_at",
        "value": "Created At",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_by",
        "value": "Created By",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "customer_image",
        "value": "Customer Image",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "customer_name",
        "value": "Customer Name",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "email",
        "value": "Email",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "feedback_time",
        "value": "Feedback Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "lead_assign_time",
        "value": "Lead Assign Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "lead_source",
        "value": "Lead Source",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "location",
        "value": "Location",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "lost_reason",
        "value": "Lost Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "modified_at",
        "value": "Modified At",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "call_response_time",
        "value": "Call Response Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "next_follow_up_date_time",
        "value": "Next Follow Up Date Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "next_follow_up_type",
        "value": "Next Follow Up Type",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "not_int_reason",
        "value": "Not Int Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "organization_id",
        "value": "Organization Id",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "other_lost_reason",
        "value": "Other Lost Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "other_not_int_reason",
        "value": "Other Not Int Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "previous_owner",
        "value": "Previous Owner",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "project",
        "value": "Project",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "property_stage",
        "value": "Property Stage",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "property_type",
        "value": "Property Type",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "source_status",
        "value": "Source Status",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "stage",
        "value": "Stage",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "stage_change_at",
        "value": "Stage Change At",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "transfer_status",
        "value": "Transfer Status",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "uid",
        "value": "Uid",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "addset",
        "value": "Addset",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "campaign",
        "value": "Campaign",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "inventory_type",
        "value": "Inventory Type",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "property_sub_type",
        "value": "Property Sub Type",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "transfer_reason",
        "value": "Transfer Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "previous_owner_1",
        "value": "Previous Owner 1",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "previous_owner_2",
        "value": "Previous Owner 2",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "transfer_by_1",
        "value": "Transfer By 1",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "transfer_by_2",
        "value": "Transfer By 2",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "previous_stage_1",
        "value": "Previous Stage 1",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "previous_stage_2",
        "value": "Previous Stage 2",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "call_back_reason",
        "value": "Call Back Reason",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "is_button_called",
        "value": "Is Button Called",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "field_one",
        "value": "Field One(Number)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "field_two",
        "value": "Field Two(Number)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "field_three",
        "value": "Field Three(Text)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "field_four",
        "value": "Field Four(Text)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "field_five",
        "value": "Field five(Text)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "field_six",
        "value": "Field Six(Text)",
        "is_mandatory": "false",
        "hide_field": "false"
    },
    {
        "label": "organization_name",
        "value": "Organization Name",
        "is_mandatory": "true",
        "hide_field": "false"
    }
]

export const taskHeader=[
    {
        "label": "leadId",
        "value": "Lead ID",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "customer_name",
        "value": "Customer Name",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "contact_no",
        "value": "Contact No",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "stage",
        "value": "Stage",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "contact_owner_email",
        "value": "Contact Owner Email",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "call_back_reason",
        "value": "Call Back Reason",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "location",
        "value": "Location",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "project",
        "value": "Project",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "budget",
        "value": "Budget",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "transfer_status",
        "value": "Transfer Status",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "unique_meeting",
        "value": "Unique Meeting",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "unique_site_visit",
        "value": "Unique Site Visit",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "created_by",
        "value": "Created By",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_at",
        "value": "Created At",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "type",
        "value": "Task Type",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "inventory_type",
        "value": "Inventory Type",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "source",
        "value": "Source",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "due_date",
        "value": "Due Date & Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "completed_at",
        "value": "Completed Date & Time",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "status",
        "value": "Status",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "uid",
        "value": "User Id",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "organization_id",
        "value": "Organization Id",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "organization_name",
        "value": "Organization Name",
        "is_mandatory": "true",
        "hide_field": "false"
    }
]

export const callLogHeaders=[
    {
        "label": "leadId",
        "value": "Lead ID",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "customer_name",
        "value": "Customer Name",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "contact_no",
        "value": "Contact No",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "stage",
        "value": "Stage",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "contact_owner_email",
        "value": "Contact Owner Email",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "location",
        "value": "Location",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "project",
        "value": "Project",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "budget",
        "value": "Budget",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "transfer_status",
        "value": "Transfer Status",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_by",
        "value": "Created BY",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "created_at",
        "value": "Created Date & Time",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "inventory_type",
        "value": "Inventory Type",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "duration",
        "value": "Duration",
        "is_mandatory": "true",
        "hide_field": "false"
    },
    {
        "label": "uid",
        "value": "User ID",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "organization_id",
        "value": "Organization ID",
        "is_mandatory": "true",
        "hide_field": "true"
    },
    {
        "label": "organization_name",
        "value": "Organization Name",
        "is_mandatory": "true",
        "hide_field": "false"
    }
]